module.exports = __webpack_public_path__ + "static/img/解决方案-煤矿反三违-软硬件一体快速部署.cb5a76a1.png";